/**
 * @generated SignedSource<<b83ccbb2d664b698a1d0314ef61e6e0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingHolidayDelivery_viewer$data = {
  readonly holidayRelevantShipping?: {
    readonly shipmentQuotes: ReadonlyArray<{
      readonly buyerServiceMethodDisplay: string | null;
      readonly isComplimentary: boolean | null;
      readonly serviceId: string | null;
      readonly serviceMethod: {
        readonly region: {
          readonly code: string | null;
        } | null;
        readonly serviceMethodType: string | null;
        readonly serviceType: string | null;
      } | null;
      readonly totalAmount: {
        readonly amount: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly transactionWarnings?: {
    readonly hasRestrictedMaterials: boolean | null;
    readonly isCheckoutBlocked: boolean | null;
  } | null;
  readonly " $fragmentType": "PdpSharedShippingHolidayDelivery_viewer";
};
export type PdpSharedShippingHolidayDelivery_viewer$key = {
  readonly " $data"?: PdpSharedShippingHolidayDelivery_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingHolidayDelivery_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "mlFreightQuotesv2TestArm"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingHolidayDelivery_viewer",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "country",
              "variableName": "userCountryCode"
            },
            (v0/*: any*/)
          ],
          "concreteType": "TransactionWarningQueryType",
          "kind": "LinkedField",
          "name": "transactionWarnings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasRestrictedMaterials",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isCheckoutBlocked",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "holidayRelevantShipping",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            },
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            (v0/*: any*/),
            {
              "kind": "Variable",
              "name": "mlFreightQuotesv2TestArm",
              "variableName": "mlFreightQuotesv2TestArm"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "userZipCode"
            }
          ],
          "concreteType": "RelevantShippingInfo",
          "kind": "LinkedField",
          "name": "relevantShipping",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ShipmentQuote",
              "kind": "LinkedField",
              "name": "shipmentQuotes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isComplimentary",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "buyerServiceMethodDisplay",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "totalAmount",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "amount",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ShipmentServiceMethod",
                  "kind": "LinkedField",
                  "name": "serviceMethod",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "serviceType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "serviceMethodType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Region",
                      "kind": "LinkedField",
                      "name": "region",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "e3bf498e9f44fd484bb4d65b1f18098f";

export default node;
